<div class="module-selection-wrapper" [ngClass]="{ 'not-allow': isFreeUser }" droppable="false"
     [attr.data-position]="module.position"
     [dragOverClass]="'drag-target-border'"
     [dropScope]="'module'"
     [dragHintClass]="'drag-hint'"
     (onDrop)="onAnyDrop($event)">
  <div class="module-selection" [ngClass]="{ 'not-allow': isFreeUser, 'read-only': !canEditable }" draggable="false"
       [dragClass]="'drag-over'"
       [dragData]="dropData"
       [dragScope]="'module'">
    <div class="d-flex flex-row flex-nowrap align-items-center"
         actionByLevels="Edit Project"
         [wallName]="'Reports Disabled'"
         [actionData]="measureActionContext"
         (afterChecking)="onActivatedModule(module.id)"
         [ngClass]="{ 'not-allow': isFreeUser }" >
      <div class="module-icon-wrapper">
        <img src="{{iconPath}}" width="30" height="30">
      </div>
      <div class="module-content d-flex flex-column flex-auto">
        <div class="d-flex flex-row justify-content-start align-items-center">
          <span class="module-title">{{'measure.module_selection_label' | translate}}</span>
          <img src={{checkmarkIcon}} width="15" height="15">
        </div>
        <div class="module-desc text-semi-bold-font">
          {{moduleName}}
        </div>
      </div>
      <div class="drag-bar module-icon-detail d-flex drag-icon">
      </div>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/main/measure/measure-modules-selection/measure-modules-selection.component.html